module.exports = __webpack_public_path__ + "img/male2.c19a0c5b.jpg";